/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/directive/index.js
 */

import LongPress from './longpress'
import NumberOnly from './numberOnly'
import PriceConverter from './price-converter'
import Tooltip from './tooltip-v2'

export default (Vue) => {
    Vue.directive('longpress', LongPress)
    Vue.directive('numericOnly', NumberOnly)
    Vue.directive('price-converter', PriceConverter)
    Vue.directive('tooltip', Tooltip)
}

